import React, { useEffect, useRef, useState } from "react";
import "@/assets/css/zoomable-image.css";
import SearchIcon from "@/assets/icons/search.png";
import ContainerSkeleton from "@/components/skeletons/ContainerSkeleton";

const InnerZoomedImage = ({ src, alt = "Zoomable Image", custCls = "" }) => {
  const [zoomed, setZoomed] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const imgRef = useRef(null);

  const handleMouseMove = (e) => {
    if (!imgRef.current) return;
    const rect = imgRef.current.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setOffset({ x, y });
  };

  return (
    <div
      className={`relative overflow-hidden border w-full mx-auto aspect-square hover:cursor-zoom-in ${custCls}`}
      onMouseEnter={() => setZoomed(true)}
      onMouseLeave={() => setZoomed(false)}
      onMouseMove={handleMouseMove}
    >
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        className="w-full h-full object-cover transition duration-200"
        draggable={false}
      />
      {zoomed && (
        <div
          className="absolute inset-0 pointer-events-none rounded-lg"
        >
          <div
            className="absolute w-[200%] h-[200%] left-1/2 z-20 top-1/2"
            style={{
              transform: `translate(-${offset.x}%, -${offset.y}%) scale(1.5)`,
              backgroundImage: `url(${src})`,
              backgroundSize: "cover",
              backgroundPosition: `${offset.x}% ${offset.y}%`,
              borderRadius: "inherit",
              boxShadow: "0 0 16px 0 #0002"
            }}
          />
        </div>
      )}
      {/* Search icon pojok kiri atas */}
      <img
        src={SearchIcon}
        alt="search icon"
        className="absolute top-2 md:top-4 left-2 md:left-4 w-5 md:w-10 h-5 md:h-10"
        style={{ pointerEvents: "none" }}
      />
    </div>
  );
};

const ImageMagnifier = ({ product }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const imgRef = useRef(null);
  const popupWidth = 50
  const popupHeight = 50
  const [currNaturalW, setCurrNaturalW] = useState(0);
  const [currNaturalH, setCurrNaturalH] = useState(0);
  const [mouse, setMouse] = useState({ x: 0, y: 0 });
  const [isLoaded, setIsLoaded] = useState(false);

  const handleMouseMove = (e) => {
    const rect = imgRef.current.getBoundingClientRect();
    const naturalW = imgRef.current.naturalWidth;
    const naturalH = imgRef.current.naturalHeight;
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    // Rasio posisi mouse terhadap gambar tampilan
    const ratioX = x / rect.width;
    const ratioY = y / rect.height;
    // Posisi pada gambar asli
    const bgX = ratioX * naturalW;
    const bgY = ratioY * naturalH;
    setPos({ x: bgX, y: bgY, ratioX, ratioY });
    setMouse({ x, y }); // simpan posisi mouse relatif ke tampilan

    setCurrNaturalW(naturalW);
    setCurrNaturalH(naturalH);
  };

  useEffect(() => {
    if (isLoaded) setIsLoaded(false);
    if (!product.img.src && !product.img.src) return;

    const img = new Image();
    img.src = product.img.src;
    img.onload = () => {
      setIsLoaded(true);
    };

    img.onerror = () => {
      console.log("Failed load image!");
      setIsLoaded(true);
    };
  }, [product.img]);

  return !isLoaded ?
    <ContainerSkeleton custH={product.isSingle ? "h-[200px] sm:h-[350px] lg:h-[550px] 2xl:h-[820px]" : "h-[170px] sm:h-[260px] lg:h-[380px] 2xl:h-[650px]"} custW="w-full" />
    :
    <div className="relative">
      <img
        ref={imgRef}
        src={product.img.src}
        srcSet={product.img.srcSet}
        alt={product.name}
        className={"w-full h-full object-cover " + (product.isSingle ? "h-[200px] sm:h-[350px] lg:h-[550px] 2xl:h-[820px]" : "h-[170px] sm:h-[260px] lg:h-[380px] 2xl:h-[650px]")}
        onMouseMove={handleMouseMove}
        onMouseEnter={() => setShowPopup(true)}
        onMouseLeave={() => setShowPopup(false)}
      />
      {showPopup && (
        <div
          style={{
            position: 'absolute',
            left: mouse.x + 20,
            top: mouse.y,
            width: popupWidth,
            height: popupHeight,
            overflow: 'hidden',
            border: '1px solid #ccc',
            background: `url(${product.img.src}) -${pos.x - popupWidth / 2}px -${pos.y - popupHeight / 2}px / ${currNaturalW}px ${currNaturalH}px no-repeat`
          }}
        />
      )}
    </div>
};

export {
  InnerZoomedImage,
  ImageMagnifier
};
